import { useCallback, useState } from 'react'

const COPIED_RESET_MS = 1400

/**
 * Copies text to the clipboard and reports "just copied" for a moment — the
 * same feedback window every copy button in the app uses, so a founder never
 * sees one button say "Copied" while an identical button beside it still
 * says "Copy".
 */
export function useCopyToClipboard() {
  const [copied, setCopied] = useState(false)

  const copy = useCallback((text: string | null | undefined) => {
    if (!text) return
    void navigator.clipboard.writeText(text)
    setCopied(true)
    setTimeout(() => setCopied(false), COPIED_RESET_MS)
  }, [])

  return { copied, copy }
}
